import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=2fefcade&scoped=true&"
import script from "./CancelOrder.vue?vue&type=script&lang=js&"
export * from "./CancelOrder.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=2fefcade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fefcade",
  null
  
)

export default component.exports